export default "__VITE_ASSET__FEiBd_3G__"